export class ManifestValidationException extends Error {

	constructor(type: string) {

		super(`Manifest validation: no valid ${type} property defined.`);
		this.name = "ManifestValidationException";
	}
}
